// extracted by mini-css-extract-plugin
module.exports = {"skill":"SkillSingle_skill__2Sfnt"};